import { TRAINING_DEFAULT_VIEW } from 'constants/actionTypes';
import { VIEW_TYPES } from '../../actions/inPersonTraining/defaultView';

export default (defaultView = VIEW_TYPES.UNSET, action) => {
  switch (action.type) {
    case TRAINING_DEFAULT_VIEW.SET_VIEW_STATE:
      return action.view;

    default:
      return defaultView;
  }
};
